import { render, staticRenderFns } from "./RipaConfirmation.vue?vue&type=template&id=a424417e"
import script from "./RipaConfirmation.vue?vue&type=script&lang=js"
export * from "./RipaConfirmation.vue?vue&type=script&lang=js"
import style0 from "./RipaConfirmation.vue?vue&type=style&index=0&id=a424417e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports